/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-09-30 12:27:56
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-11-02 09:41:42
 * @FilePath: /wemeet-web-activity/src/components/ImageWithFallback/index.tsx
 * @Description: 给个默认头像
 */
import React, { FC, useState, useCallback, useEffect } from 'react';
import DefaultAvatar from '@assets/imgs/default-avatar.svg';

const ImageWithFallback: FC<{
  src?: string;
  fallback?: string;
  className?: string;
  [key: string]: any;
}> = ({ src, fallback = DefaultAvatar, className }) => {
  const [cur, setCur] = useState(src || fallback);

  const onErr = useCallback(() => {
    if (cur === fallback || !fallback) return;
    setCur(fallback);
  }, [src, cur, fallback]);

  useEffect(() => {
    setCur(src || fallback);
  }, [src, setCur, fallback]);

  return <img src={cur || src} onError={onErr} className={className} />;
};

export default ImageWithFallback;
